<template>
  <div>
    <v-layout row container justify-center>
      <v-dialog v-model="dialog" max-width="1000">
        <v-card light class="pr-5 pl-5 pt-4 pb-4">
            <span class="subheadline">Observaciones</span>
            <observaciones-cuota :cuotaId="cuotaId" :canEdit="canEdit"></observaciones-cuota>
        </v-card>
      </v-dialog>
        <v-badge dot overlap right color="red" slot="activator">
            <span slot="badge" v-if="tieneNotificaciones">!</span>
            <v-btn align="center" justify="center" @click="openDialog" color="primary">
                <slot></slot>
            </v-btn>
        </v-badge>
    </v-layout>
  </div>

</template>

<script>
import ObservacionesCuota from './ObservacionesCuota'
export default {
  components: {
    ObservacionesCuota
  },
  props: {
    cuotaId: [Number, String],
    canEdit: Boolean,
    tieneNotificaciones: Boolean
  },
  data () {
    return {
      dialog: false,
      markAsReadPath: `cuota/${this.cuotaId}/observaciones/read`
    }
  },

  methods: {
    openDialog () {
      this.dialog = true
      this.marcarComoLeidas()
    },
    marcarComoLeidas () {
      if (this.tieneNotificaciones) {
        this.axios
          .put(this.markAsReadPath)
          .then(response => {})
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
          })
      }
    }
  }
}
</script>
<style scoped>
  .subheadline {
    color: lightslategray;
    font-size: 1.6em;
    color: rgb(60, 145, 197);
    padding-top: 1.5em;
    margin-top: 2em;
  }
</style>
